import React, { useState, useEffect } from "react"
import styled from "styled-components"
import TitleHeader from "components/presenters/header/TitleHeader"
import TodoList from "components/containers/task/TodoList"
import server from "server/serverController2"
import { useSelector } from "react-redux"
import { formatDate } from "utils/utils.js"
import { format } from "date-fns"
import ko from "date-fns/locale/ko"
import Calendar from "components/containers/calendar/Calendar"
import arrowDown from "images/icon/arrow_down-13x50.png"

export default function MyCalendarLayout({ match }) {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })

  const [selectDay, setSelectDay] = useState(null)
  // 투두리스트 조회 데이터 받아오기

  const [todoList, setTodoList] = useState([])
  const [todoListRelation, setTodoListRelation] = useState(null)
  const [deletedTodoListItem, setDeletedTodoListItem] = useState(null)

  const setTodoListDataCallback = (res) => {
    if (res.success !== 1) {
      alert("예기치 못한 오류가 발생하였습니다.")
      return
    }
    let jsonData = res.data
    if (jsonData["todolist"]) {
      setTodoList(jsonData["todolist"])
    }
  }

  const handleDeleteTodoList = (deletedItem) => {
    setDeletedTodoListItem(deletedItem.task.task_date)
  }

  useEffect(() => {
    if (userInfo["isLogin"] === true) {
      setTodoListRelation("self")
    } else {
      setTodoListRelation("guest")
    }
  }, [])

  const updateTasks = () => {
    server.getRequestData(`tasks/dates/${formatDate(selectDay)}/todolist`, setTodoListDataCallback)
    server.getRequestData(`tasks/dates/${formatDate(selectDay)}/rate`, rateCallBack)
  }

  useEffect(() => {
    updateTasks()
  }, [selectDay])

  // 달성률 받아오기
  const [ratedata, setRatedata] = useState({})
  const rateCallBack = (jsonData) => {
    if (jsonData.success !== 1) {
      alert("예기치 못한 오류가 발생하였습니다.")
      return
    }
    setRatedata(jsonData.data)
  }
  const handleEditResult = (e) => {
    updateTasks()
  }

  return (
    <MypageAchieveInner>
      <TitleHeaderWrapper>
        <TitleHeader title={"캘린더"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"} />
      </TitleHeaderWrapper>

      <CalendarWrapper>
        <Calendar
          selectDay={selectDay}
          setSelectDay={setSelectDay}
          deletedTodoListItem={deletedTodoListItem}
          setDeletedTodoListItem={setDeletedTodoListItem}
          userNo={userInfo["id"]}
        />
      </CalendarWrapper>
      {selectDay ? (
        <TodoListWrapper>
          <TodoListHeader>
            <TodoListCloseBtnBlock onClick={() => setSelectDay(null)}>
              <TodoListCloseBtn>
                <TodoListCloseBtnImg src={arrowDown} />
              </TodoListCloseBtn>
            </TodoListCloseBtnBlock>
            <TodoListHeaderTxt>{`${format(selectDay, "MM월 dd일 (EEEEEE)", {
              locale: ko,
            })}`}</TodoListHeaderTxt>
          </TodoListHeader>
          <TodoList
            currentDate={selectDay}
            setCurrentDate={setSelectDay}
            todoList={todoList}
            setTodoList={setTodoList}
            userNo={userInfo["id"]}
            disableCalendar={true}
            userRelation={todoListRelation}
            onEdit={handleEditResult}
            onDeleteResult={handleDeleteTodoList}
          />
        </TodoListWrapper>
      ) : null}
    </MypageAchieveInner>
  )
}

const MypageAchieveInner = styled.div`
  overflow: hidden;
  display: flex;
  flex-flow: column;
  height: 100vh;
`

const TitleHeaderWrapper = styled.div`
  flex: 0 1 auto;
  height: calc(100vw * (51 / 375));
  min-height: calc(100vw * (51 / 375));
  max-height: calc(100vw * (51 / 375));
`

const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
  padding-bottom: calc(100vw * (31 / 375));
  overflow: hidden;
`

const TodoListWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-flow: column;
  height: 100%;
  background: #f7f7f7;
  overflow: hidden;
`

const TodoListHeader = styled.div`
  padding: calc(100vw * (13 / 375)) calc(100vw * (27 / 375)) 0;
  flex: 1 1 auto;
`

const TodoListCloseBtnBlock = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: calc(100vw * (13.9 / 375));
`

const TodoListCloseBtn = styled.button`
  width: calc(100vw * (24.6 / 375));
  height: calc(100vw * (6.1 / 375));
`

const TodoListCloseBtnImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const TodoListHeaderTxt = styled.div`
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
  color: #121212;
  font-weight: 700;
`
